import React, { useState } from 'react'
import LazyLoad from 'react-lazyload';
import { useNavigate } from 'react-router-dom';
import LazyLoader from '../../views/lazyloader';
import FooterLogo from "../../assets/images/footer_logo.png";
import NftAudio from "../../components/NftAudio";
import NftVideo from "../../components/NftVideo";

function PreviewCard(props) {

  const navigate = useNavigate()

  const [starRate, setstarRate] = useState(0);
  
  const { previewFile, previewThumb, NFTName } = props;

  const randomnumber = ()=> {return Math.floor(Math.random() * 100)};
  return (
    <>
      <div class="card previewy_card">
        {
          previewFile?.type?.includes('pdf') ?
            <a href={URL.createObjectURL(previewFile)} target='blank'>
              <LazyLoad
                height={200}
                placeholder={<LazyLoader />}
                offset={[-200, 0]}
                debounce={500}
              >
                {previewFile && (previewFile?.type?.includes('audio') ?
                  <NftAudio
                    file={previewFile}
                    cover={typeof (previewThumb) == 'string' ? previewThumb+"?"+randomnumber() : (previewThumb ? URL.createObjectURL(previewThumb) : FooterLogo)}
                    mimeType={previewFile.type}
                    label={NFTName || "Audio NFT preview"}
                    preload="none"
                  />
                  : (previewFile?.type?.includes('video') ?
                    <>
                      <NftVideo
                        file={previewFile}
                        mediaName={previewFile.name}
                        mimeType={previewFile.type}
                        label="NFT video preview"
                      />
                    </>
                    :
                    (
                      previewFile?.type?.includes('pdf') ?
                        <>
                          <iframe
                            src={URL.createObjectURL(previewFile)} className="img-fluid" loading="lazy"
                          ></iframe>
                        </>
                        :
                        <img src={typeof (previewFile) == 'string' ? previewFile+"?"+randomnumber() : URL.createObjectURL(previewFile)} class="card-img-top previewy_cardban" />)))}


              </LazyLoad>
            </a>
            :
            <LazyLoad
              height={200}
              placeholder={<LazyLoader />}
              offset={[-200, 0]}
              debounce={500}
            >
              {previewFile && (previewFile?.type?.includes('audio') ?
                <NftAudio
                  file={previewFile}
                  cover={typeof (previewThumb) == 'string' ? previewThumb+"?"+randomnumber() : (previewThumb ? URL.createObjectURL(previewThumb) : FooterLogo)}
                  mimeType={previewFile.type}
                  label={NFTName || "Audio NFT preview"}
                  preload="none"
                />
                : (previewFile?.type?.includes('video') ?
                  <>
                    <NftVideo
                      file={previewFile}
                      mediaName={previewFile.name}
                      mimeType={previewFile.type}
                      label="NFT video preview"
                    />
                  </>
                  :
                  (
                    previewFile?.type?.includes('pdf') ?
                      <>
                        <iframe
                          src={URL.createObjectURL(previewFile)} className="img-fluid" loading="lazy"
                        ></iframe>
                      </>
                      :
                      <img src={typeof (previewFile) == 'string' ? previewFile+"?"+randomnumber()  : URL.createObjectURL(previewFile)} class="card-img-top previewy_cardban" />)))}
            </LazyLoad>
        }

        <div class="card-body previewy_card_body">
          <div class="previewy_card_ttl">
            <h3 className='previewy_name'>{NFTName ?? "Card Name"}</h3>

            <div className={"star-rating updated star" + starRate}>

              {
                [1, 2, 3, 4, 5].map((val, ind) => {
                  return (
                    <>
                      <input
                        id={`star-${val}`}
                        type="radio"
                        name="rating"
                        value={`star-${val}`}
                        checked={true}
                      />
                      <label for={`star-${val}`} title={`${val} stars`} className={`five activeStar`}>
                        <i
                          className="active fa fa-star"
                          aria-hidden="true"
                        ></i>
                      </label>
                    </>
                  )
                })
              }

              {/* <input id="star-5" type="radio" name="rating" value="star-5" />
              <label for="star-5" title="5 stars" className="five">
                <i className="active fa fa-star" aria-hidden="true"></i>
              </label>
              <input id="star-4" type="radio" name="rating" value="star-4" />
              <label for="star-4" title="4 stars" className="four">
                <i className="active fa fa-star" aria-hidden="true"></i>
              </label>
              <input id="star-3" type="radio" name="rating" value="star-3" />
              <label for="star-3" title="3 stars" className="three">
                <i className="active fa fa-star" aria-hidden="true"></i>
              </label>
              <input id="star-2" type="radio" name="rating" value="star-2" />
              <label for="star-2" title="2 stars" className="two">
                <i className="active fa fa-star" aria-hidden="true"></i>
              </label>
              <input id="star-1" type="radio" name="rating" value="star-1" />
              <label for="star-1" title="1 star" className="one">
                <i className="active fa fa-star" aria-hidden="true"></i>
              </label> */}
            </div>

          </div>
          <div className='previewy_card_ttl'>
            <p className='previewy_price'>Token Price</p>
            <img className='previewy_nbn' src={require('../../assets/images/bnbdesign.png')} />
          </div>

          <div className='previewy_bot'>
            <div className='noimg_address'>
              <img className='noimage_previewy' src={require('../../assets/images/noimage.png')} />
              <img className='noimage_previewy' src={require('../../assets/images/noimage.png')} />
              <p className='previewy_addre'>@Preview</p>
            </div>
            <div className="hearting">
              <i className="far fa-heart" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PreviewCard
